import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const HidePasswordIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 27 10">
      <path
        d="M17 6.6C17 6.6 13.4188 12.2 9 12.2C4.58122 12.2 1 6.6 1 6.6C1 6.6 4.58122 1 9 1C13.4188 1 17 6.6 17 6.6Z"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00002 8.99996C10.3255 8.99996 11.4 7.92545 11.4 6.59996C11.4 5.27448 10.3255 4.19996 9.00002 4.19996C7.67454 4.19996 6.60002 5.27448 6.60002 6.59996C6.60002 7.92545 7.67454 8.99996 9.00002 8.99996Z"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

const EditIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        d="M4.42528 12.1964L1 13L1.80361 9.57525L10.0675 1.31029C10.4812 0.896569 11.1529 0.896569 11.5661 1.31029L12.6902 2.4344C13.1034 2.84812 13.1034 3.51877 12.6902 3.93302L4.42528 12.1964Z"
        stroke="#474747"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5583 5.06353L8.94141 2.43604"
        stroke="#474747"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.56067 12.0613L1.93848 9.43909"
        stroke="#474747"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

const ShowPasswordIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 27 10">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8245 4.90734C13.9863 4.68358 14.2989 4.63338 14.5227 4.79521C15.4001 5.42977 16.1142 6.09573 16.6087 6.60239C16.8564 6.85614 17.0501 7.07104 17.1828 7.22361C17.2492 7.29992 17.3003 7.36073 17.3354 7.40311C17.353 7.4243 17.3665 7.44089 17.3759 7.45252L17.3869 7.46619L17.3901 7.47015L17.3911 7.4714C17.3911 7.4714 17.3917 7.47215 16.9997 7.78261C17.3917 8.09304 17.3915 8.09332 17.3915 8.09332L17.3903 8.09478L17.3876 8.09817L17.3783 8.10976C17.3703 8.11959 17.359 8.13359 17.3442 8.15148C17.3147 8.18725 17.2717 8.23861 17.216 8.30331C17.1045 8.43268 16.9416 8.61567 16.7327 8.83442C16.3155 9.27134 15.7118 9.85398 14.9645 10.4376C13.4823 11.595 11.3734 12.8043 8.99977 12.8043C8.22117 12.8043 7.47218 12.6747 6.76596 12.4599C6.50177 12.3796 6.35272 12.1003 6.43305 11.8361C6.51339 11.5719 6.79269 11.4228 7.05689 11.5032C7.68215 11.6933 8.3328 11.8043 8.99977 11.8043C11.0449 11.8043 12.936 10.7528 14.3491 9.64938C15.0494 9.10252 15.6172 8.55473 16.0095 8.14383C16.1412 8.00588 16.2529 7.8837 16.3427 7.78262C16.2274 7.65296 16.0764 7.48867 15.8932 7.30091C15.4269 6.82323 14.7559 6.19806 13.9366 5.6055C13.7129 5.44367 13.6627 5.13109 13.8245 4.90734ZM16.9997 7.78261L17.3915 8.09332C17.5355 7.91142 17.5352 7.65329 17.3911 7.4714L16.9997 7.78261Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.65676 7.7825C1.74665 7.68142 1.85825 7.55926 1.98996 7.42133C2.38232 7.01043 2.95009 6.46263 3.65041 5.91577C5.06348 4.81234 6.95454 3.76083 8.99971 3.76083C9.55098 3.76083 10.0929 3.83719 10.6178 3.97134C10.8853 4.03972 11.1577 3.87827 11.226 3.61072C11.2944 3.34318 11.133 3.07086 10.8654 3.00248C10.2689 2.85002 9.64356 2.76083 8.99971 2.76083C6.62611 2.76083 4.51718 3.97017 3.03495 5.1276C2.28763 5.71117 1.68393 6.29381 1.26672 6.73073C1.05785 6.94948 0.894981 7.13248 0.783491 7.26184C0.727728 7.32655 0.684763 7.3779 0.655266 7.41367C0.640516 7.43156 0.629128 7.44556 0.621186 7.45539L0.611867 7.46698L0.609165 7.47037L0.608306 7.47145C0.608306 7.47145 0.607776 7.47212 0.999736 7.78255L0.608306 7.47145C0.464232 7.65336 0.463724 7.91116 0.607828 8.09304L0.999736 7.78255C0.607828 8.09304 0.607828 8.09304 0.607828 8.09304L0.609411 8.09504L0.612564 8.09898L0.623538 8.11261C0.632914 8.12419 0.646397 8.14072 0.663878 8.16183C0.698836 8.20404 0.749808 8.26462 0.815921 8.34065C0.948097 8.49265 1.14108 8.70677 1.38789 8.95967C1.88069 9.46465 2.59229 10.1286 3.46675 10.7621C3.69038 10.9241 4.003 10.8741 4.165 10.6505C4.32699 10.4268 4.27703 10.1142 4.0534 9.95223C3.23673 9.36064 2.56816 8.73731 2.10357 8.26125C1.92154 8.07472 1.77148 7.91147 1.65676 7.7825Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9997 5.50001C7.73907 5.50001 6.7171 6.52145 6.7171 7.78261C6.7171 8.05876 6.49325 8.28261 6.2171 8.28261C5.94096 8.28261 5.7171 8.05876 5.7171 7.78261C5.7171 5.969 7.18695 4.50001 8.9997 4.50001C9.27584 4.50001 9.4997 4.72387 9.4997 5.00001C9.4997 5.27616 9.27584 5.50001 8.9997 5.50001Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7823 7.28261C12.0584 7.28261 12.2823 7.50647 12.2823 7.78261C12.2823 9.59622 10.8124 11.0652 8.9997 11.0652C8.72356 11.0652 8.4997 10.8414 8.4997 10.5652C8.4997 10.2891 8.72356 10.0652 8.9997 10.0652C10.2603 10.0652 11.2823 9.04377 11.2823 7.78261C11.2823 7.50647 11.5062 7.28261 11.7823 7.28261Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1359 0.646447C16.3311 0.841709 16.3311 1.15829 16.1359 1.35355L2.57071 14.9187C2.37545 15.114 2.05886 15.114 1.8636 14.9187C1.66834 14.7235 1.66834 14.4069 1.8636 14.2116L15.4288 0.646447C15.624 0.451184 15.9406 0.451184 16.1359 0.646447Z"
        fill="white"
      />
    </SvgIcon>
  );
};

const ChevronIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22">
      <path
        d="M16.627 8.37707L11.127 13.8771L5.62695 8.37708"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

const BillingIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <ellipse cx="10" cy="10" rx="5" ry="5" stroke="white" />
      <path
        d="M11.25 7.61486C11.25 7.61486 10.625 7.61486 10 7.61486M10 6.875C10 6.875 10 7.02083 10 7.61486M10 7.61486C10 8.49127 10 9.08663 10 9.96304M10 7.61486C9.375 7.61486 8.75 8.00549 8.75 8.78674C8.75 9.56799 9.2357 9.96304 10 9.96304M10 9.96304C10.7643 9.96304 11.25 10.3492 11.25 11.1305C11.25 11.9117 10.625 12.3024 10 12.3024M10 9.96304C10 10.7755 10 11.4899 10 12.3024M10 12.3024C9.57032 12.3024 8.75 12.3024 8.75 12.3024M10 12.3024C10 12.7782 10 12.6491 10 13.125"
        stroke="white"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

const UserCountIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        d="M15 9.75C15 9.75 12.7617 13.25 10 13.25C7.23826 13.25 5 9.75 5 9.75C5 9.75 7.23826 6.25 10 6.25C12.7617 6.25 15 9.75 15 9.75Z"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11.25C10.8284 11.25 11.5 10.5784 11.5 9.75C11.5 8.92157 10.8284 8.25 10 8.25C9.17157 8.25 8.5 8.92157 8.5 9.75C8.5 10.5784 9.17157 11.25 10 11.25Z"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

const RefreshIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 27 10">
      <path
        d="M0.5 4.14551L1.98157 6.35219L3.68536 4.3119"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4998 6.43173L11.0188 4.22559L9.31445 6.26587"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9986 4.24512C11.4419 6.58842 9.79026 8.88547 7.5384 9.41707C5.96805 9.78866 4.39344 9.29055 3.32227 8.23479"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.98443 6.33878C1.28591 3.74297 3.03116 1.19554 5.46004 0.622471C7.13778 0.225364 8.81764 0.820226 9.88509 2.02643"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
const InfoIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 21">
      <path
        d="M14.9993 10.3805C15.047 13.1415 12.7615 15.4189 10 15.467C7.23901 15.5143 5.04848 13.3155 5.00075 10.5541C4.95256 7.7941 7.23901 5.51582 10 5.46855C12.761 5.42038 14.9515 7.62004 14.9993 10.3805V10.3805Z"
        stroke="#D6D6D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11.1496V7.96777"
        stroke="#D6D6D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 12.9678C10.5 13.2438 10.276 13.4678 10 13.4678C9.724 13.4678 9.5 13.2438 9.5 12.9678C9.5 12.6918 9.724 12.4678 10 12.4678C10.276 12.4678 10.5 12.6918 10.5 12.9678Z"
        fill="#D6D6D6"
      />
    </SvgIcon>
  );
};

const SearchIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        d="M10.6573 5.59743C10.6573 8.11584 8.51658 10.1949 5.82866 10.1949C3.14073 10.1949 1 8.11584 1 5.59743C1 3.07901 3.14073 1 5.82866 1C8.51658 1 10.6573 3.07901 10.6573 5.59743Z"
        stroke="white"
        strokeLinecap="round"
      />
      <path d="M9.20215 9.29492L11.4923 11.5" stroke="white" strokeLinecap="round" />
    </SvgIcon>
  );
};

const AddIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 21">
      <path
        d="M12 6V18"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 12H6"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

const TrashIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M8.34961 7.59998H16.3496V18H8.34961V7.59998Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.75 7.6V7.6C10.75 6.71634 11.4663 6 12.35 6V6C13.2337 6 13.95 6.71634 13.95 7.6V7.6"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 7.59998H17.95"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1504 10V15.6"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5498 10V15.6"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

const EditButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      width="1"
      height="1"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.42528 12.1964L1 13L1.80361 9.57525L10.0675 1.31029C10.4812 0.896569 11.1529 0.896569 11.5661 1.31029L12.6902 2.4344C13.1034 2.84812 13.1034 3.51877 12.6902 3.93302L4.42528 12.1964Z"
        stroke="#474747"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5583 5.06353L8.94141 2.43604"
        stroke="#474747"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.56067 12.0613L1.93848 9.43909"
        stroke="#474747"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
const CheckIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 21">
      <svg
        width="14"
        height="10"
        viewBox="0 0 14 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 0.5L4 8.9L1 5.9"
          stroke="#333333"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

const UploadFileIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" fill="none">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M2.892 3.392c-.483.483-.767 1.414-.767 3.504v10.416c0 2.09.284 3.021.767 3.504.483.483 1.414.767 3.504.767h10.416c2.09 0 3.021-.284 3.504-.767.483-.483.767-1.413.767-3.503v-6.25c0-2.09-.284-3.021-.767-3.504-.483-.483-1.413-.767-3.503-.767h-3.125c-.606 0-1.118-.09-1.561-.357-.391-.236-.646-.573-.818-.802l-.035-.045-.003-.005L9.708 3.5c-.319-.426-.448-.578-.62-.68-.148-.09-.43-.195-1.13-.195H6.396c-2.09 0-3.02.284-3.504.767ZM1.566 2.066C2.646.986 4.32.75 6.396.75h1.562c.863 0 1.534.124 2.096.462.516.31.848.754 1.117 1.112l.037.051 1.561 2.08c.221.292.272.342.328.375.031.02.154.087.59.087h3.126c2.076 0 3.75.237 4.83 1.316 1.078 1.08 1.315 2.753 1.315 4.83v6.25c0 2.076-.236 3.75-1.316 4.83-1.08 1.078-2.753 1.315-4.83 1.315H6.396c-2.077 0-3.75-.236-4.83-1.316S.25 19.39.25 17.312V6.896c0-2.077.237-3.75 1.316-4.83Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M11.992 10.854c.517 0 .937.42.937.938v2.187h2.113a.938.938 0 0 1 0 1.875h-2.113v2.188a.938.938 0 0 1-1.875 0v-2.188H8.792a.938.938 0 0 1 0-1.875h2.262v-2.187c0-.518.42-.938.938-.938Z"
      clipRule="evenodd"
    />
  </svg>
);

const FileIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M3.288 3.288c-.484.483-.767 1.414-.767 3.504v10.416c0 2.09.283 3.02.767 3.504.483.483 1.413.767 3.503.767h10.417c2.09 0 3.02-.284 3.504-.767.483-.483.767-1.414.767-3.504v-6.25c0-2.09-.284-3.02-.767-3.503-.483-.484-1.414-.768-3.504-.768h-3.125c-.605 0-1.118-.088-1.56-.356-.392-.237-.646-.573-.819-.802l-.034-.045-.004-.005-1.562-2.083c-.32-.426-.449-.578-.62-.681-.148-.09-.43-.194-1.13-.194H6.79c-2.09 0-3.02.284-3.503.767ZM1.962 1.962C3.042.882 4.715.646 6.792.646h1.562c.862 0 1.534.124 2.096.462.515.31.848.754 1.116 1.112l.038.05 1.56 2.082c.222.29.273.34.328.374.032.02.155.086.591.086h3.125c2.077 0 3.75.237 4.83 1.317 1.079 1.08 1.316 2.753 1.316 4.83v6.25c0 2.076-.237 3.75-1.316 4.829-1.08 1.08-2.753 1.316-4.83 1.316H6.791c-2.076 0-3.75-.237-4.83-1.316-1.079-1.08-1.315-2.753-1.315-4.83V6.792c0-2.077.236-3.75 1.316-4.83Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M6.896 1.583c0-.518.42-.937.937-.937h9.375c1.186 0 2.248.297 3.007 1.056.758.758 1.055 1.82 1.055 3.006v1.438a.937.937 0 1 1-1.875 0V4.708c0-.897-.223-1.398-.506-1.68-.283-.284-.784-.507-1.681-.507H7.833a.937.937 0 0 1-.937-.938Z"
      clipRule="evenodd"
    />
  </svg>
);

const TimesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none">
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="m.75.75 10.5 10.5M11.25.75.75 11.25"
    />
  </svg>
);

const DownloadIcon = (props: SvgIconProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M8.977 5.077c.027-.31.3-.54.609-.512 1.209.104 2.173.477 2.816 1.27.63.777.867 1.854.867 3.171v.082c0 1.452-.288 2.615-1.074 3.401-.786.786-1.949 1.073-3.401 1.073H4.725c-1.453 0-2.616-.287-3.402-1.073S.25 10.54.25 9.087v-.08c0-1.308.233-2.38.853-3.154.633-.792 1.584-1.17 2.776-1.282a.562.562 0 1 1 .104 1.12c-1.02.095-1.629.398-2.002.864-.386.483-.606 1.246-.606 2.451v.082c0 1.34.272 2.134.744 2.606.472.471 1.265.743 2.606.743h4.069c1.341 0 2.134-.271 2.606-.743s.744-1.265.744-2.607v-.08c0-1.215-.224-1.981-.615-2.464-.379-.466-.999-.768-2.04-.858a.563.563 0 0 1-.512-.608Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M6.763.25c.31 0 .562.252.562.563v8.05a.563.563 0 0 1-1.125 0V.813c0-.311.252-.563.563-.563Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M4.271 7.071c.22-.22.576-.22.795 0l1.697 1.696 1.696-1.696a.563.563 0 0 1 .795.796L7.16 9.96a.563.563 0 0 1-.795 0L4.27 7.866a.563.563 0 0 1 0-.795Z"
      clipRule="evenodd"
    />
  </svg>
);

const PublishIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" fill="none">
    <path
      stroke="#333"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="m1 4.146 1.482 2.206 1.703-2.04M13 6.432l-1.481-2.206-1.705 2.04"
    />
    <path
      stroke="#333"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M11.499 4.245c.443 2.343-1.209 4.64-3.46 5.172a4.517 4.517 0 0 1-4.217-1.182M2.484 6.339C1.786 3.743 3.531 1.196 5.96.622a4.515 4.515 0 0 1 4.425 1.404"
    />
  </svg>
);

const CheckboxIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <rect x="0.700195" y="0.5" width="23" height="23" rx="3.5" fill="#ffffff" />
      <rect x="0.700195" y="0.5" width="23" height="23" rx="3.5" stroke="#E5E5E5" />
    </SvgIcon>
  );
};

const CheckboxCheckedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <rect x="0.400391" width="24" height="24" rx="4" fill="#333333" />
      <path
        d="M6.40039 13.0039L10.3357 16.7996L18.8062 8.56592"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" fill="none">
    <path
      stroke="#5C5C5C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M13 4.7s-2.686 4.2-6 4.2-6-4.2-6-4.2S3.686.5 7 .5s6 4.2 6 4.2Z"
    />
    <path
      stroke="#5C5C5C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M7 6.5a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z"
    />
  </svg>
);

const EyeDashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" fill="none">
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M9.269 3.25A9.61 9.61 0 0 1 11 4.864S8.762 7.69 6 7.69a4.48 4.48 0 0 1-1.305-.202M2.725 6.473C1.668 5.708 1 4.864 1 4.864s2.238-2.826 5-2.826c.373 0 .738.052 1.089.141"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M4.26 4.864c0-.96.78-1.739 1.74-1.739M7.74 4.864c0 .96-.78 1.74-1.74 1.74M10.24.625 1.76 9.103"
    />
  </svg>
);

const CaretDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" fill="none">
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="m13.139 1.139-6 6-6-6"
    />
  </svg>
);

const CaretDownMenuIcon = (props: SvgIconProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="12" height="7" fill="none">
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="m11.117.617-5 5-5-5"
    />
  </svg>
);

const LiveIcon = (props: SvgIconProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none">
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 4.93C9.037 7.14 7.21 8.96 5 9c-2.209.037-3.961-1.722-4-3.93C.963 2.86 2.792 1.037 5 1 7.209.963 8.961 2.723 9 4.93v0Z"
    />
    <path
      fill="#fff"
      d="M7 4.965C7.019 6.07 6.105 6.98 5 7c-1.104.019-1.98-.86-2-1.965C2.981 3.93 3.896 3.019 5 3c1.104-.019 1.98.86 2 1.965Z"
    />
  </svg>
);

const IconError = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      fill="none"
      viewBox="0 0 20 21"
    >
      <path
        stroke="#F94F44"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 10.413c.047 2.76-2.239 5.038-5 5.086-2.761.047-4.952-2.151-5-4.913-.047-2.76 2.239-5.038 5-5.085 2.761-.048 4.951 2.151 5 4.912v0zM10 11.182V8"
      ></path>
      <path fill="#F94F44" d="M10.5 13a.5.5 0 11-1 0 .5.5 0 011 0z"></path>
    </SvgIcon>
  );
};

const CloseIcon = (props: SvgIconProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M6.75 6.75l10.5 10.5M17.25 6.75l-10.5 10.5"
    ></path>
  </svg>
);

const SmileIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" fill="none">
    <path
      fill="#fff"
      d="M7 14.563c-3.786 0-6.875-3.083-6.875-6.876C.125 3.896 3.214.813 7 .813s6.875 3.083 6.875 6.875A6.88 6.88 0 0 1 7 14.563ZM7 1.771a5.923 5.923 0 0 0-5.916 5.915A5.923 5.923 0 0 0 7 13.604a5.923 5.923 0 0 0 5.916-5.915A5.923 5.923 0 0 0 7 1.771Z"
    />
    <path
      fill="#fff"
      d="M6.96 11.751a4.205 4.205 0 0 1-3.454-1.803.474.474 0 0 1 .121-.665.474.474 0 0 1 .665.121 3.26 3.26 0 0 0 2.667 1.394c1.062 0 2.06-.518 2.667-1.394a.481.481 0 0 1 .665-.121.481.481 0 0 1 .122.665 4.205 4.205 0 0 1-3.454 1.803ZM4.565 6.071a.64.64 0 1 1 1.28 0v.64a.64.64 0 1 1-1.28 0v-.64ZM8.136 6.071a.64.64 0 1 1 1.279 0v.64a.64.64 0 1 1-1.28 0v-.64Z"
    />
  </svg>
);

const SendMessageIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M12.558 1.692c-.38-.38-1.16-.575-2.414-.157L4.194 3.52c-.967.323-1.651.685-2.083 1.042-.434.358-.56.663-.56.887 0 .223.126.528.56.885.431.356 1.115.717 2.082 1.039l1.767.588c.157.053.28.176.332.333l.59 1.766c.32.967.682 1.651 1.038 2.083.358.433.663.56.887.56.225 0 .53-.127.888-.56.356-.432.717-1.116 1.039-2.083l1.983-5.95c.415-1.254.221-2.036-.16-2.417Zm.744-.743c.792.793.882 2.075.413 3.49v.002l-1.984 5.95c-.344 1.034-.756 1.852-1.225 2.42-.469.567-1.043.942-1.699.942-.655 0-1.23-.375-1.698-.942-.47-.568-.881-1.385-1.225-2.42l-.506-1.516-1.517-.506c-1.034-.344-1.85-.756-2.42-1.225C.876 6.677.5 6.104.5 5.448c0-.655.375-1.23.941-1.698.569-.47 1.385-.883 2.42-1.228L9.81.538c1.417-.472 2.698-.383 3.49.41Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M8.807 5.27a.526.526 0 0 1 .001.743L6.3 8.529a.526.526 0 0 1-.744-.742L8.064 5.27a.526.526 0 0 1 .743 0Z"
      clipRule="evenodd"
    />
  </svg>
);

const ReplyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" fill="none">
    <path
      stroke="#333"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M1 5.267h11.534C15.001 5.267 17 7.266 17 9.732v0c0 2.467-2 4.466-4.466 4.466H10.33"
    />
    <path
      stroke="#333"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M5.267 1 1 5.267l4.267 4.266"
    />
  </svg>
);

const CalendarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" fill="none">
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M2.413 1.457H.5V11.5h11V1.457H9.587"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M3.1 1.531V.844a.344.344 0 0 0-.687 0v.687a.344.344 0 1 0 .688 0ZM9.527 1.531V.844a.344.344 0 1 0-.687 0v.687a.344.344 0 0 0 .687 0ZM3.16 1.457h5.5M.5 4.453h11"
    />
  </svg>
);

const CaretLeftIcon = () => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 13.0002L1 7.00024L7 1.00025"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CaretRightIcon = () => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 0.999999L7 7L1 13"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DragAndDropIcon = (props: SvgIconProps) => (
  <svg
    {...props}
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 41.47 41.47"
  >
    <path
      fill="#fff"
      d="m4.83,4.83c-.88.88-1.4,2.58-1.4,6.4v19.02c0,3.82.52,5.52,1.4,6.4s2.58,1.4,6.4,1.4h19.02c3.82,0,5.52-.52,6.4-1.4s1.4-2.58,1.4-6.4v-11.41c0-3.82-.52-5.52-1.4-6.4s-2.58-1.4-6.4-1.4h-5.71c-1.11,0-2.04-.16-2.85-.65-.71-.43-1.18-1.05-1.49-1.46l-.06-.08h0s-2.85-3.81-2.85-3.81c-.58-.78-.82-1.06-1.13-1.24-.27-.16-.79-.36-2.06-.36h-2.85c-3.82,0-5.52.52-6.4,1.4Zm-2.42-2.42C4.38.43,7.43,0,11.22,0h2.85c1.58,0,2.8.23,3.83.84.94.57,1.55,1.38,2.04,2.03l.07.09,2.85,3.8c.4.53.5.62.6.69.06.03.28.16,1.08.16h5.71c3.79,0,6.85.43,8.82,2.4s2.4,5.03,2.4,8.82v11.41c0,3.79-.43,6.85-2.4,8.82-1.97,1.97-5.03,2.4-8.82,2.4H11.22c-3.79,0-6.85-.43-8.82-2.4s-2.4-5.03-2.4-8.82V11.22C0,7.43.43,4.38,2.4,2.4Z"
    ></path>
    <path
      fill="#fff"
      d="m21.44,18.45c.94,0,1.71.77,1.71,1.71v3.99h3.86c.95.03,1.69.82,1.66,1.77-.03.9-.75,1.63-1.66,1.66h-3.86v4c-.03.95-.82,1.69-1.77,1.66-.9-.03-1.63-.75-1.66-1.66v-4h-4.13c-.95-.03-1.69-.82-1.66-1.77.03-.9.75-1.63,1.66-1.66h4.13v-3.99c0-.95.77-1.71,1.71-1.71Z"
    ></path>
  </svg>
);

const MutedIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0838 11.2878C19.209 11.3507 19.2885 11.4819 19.2885 11.6257V13.5272C19.2885 13.7347 19.1257 13.9029 18.9249 13.9029C18.724 13.9029 18.5612 13.7347 18.5612 13.5272V12.3988L13.1775 16.7694C13.1134 16.8214 13.0343 16.8497 12.9528 16.8497H9.47727V23.591H12.9528C13.0286 23.591 13.1025 23.6155 13.1642 23.661L18.5612 27.6442V16.6125C18.5612 16.405 18.724 16.2368 18.9249 16.2368C19.1257 16.2368 19.2885 16.405 19.2885 16.6125V28.3743C19.2885 28.515 19.2124 28.644 19.0912 28.7084C18.9701 28.7728 18.8243 28.7618 18.7135 28.68L12.8363 24.3425H9.11364C8.91281 24.3425 8.75 24.1743 8.75 23.9668V16.474C8.75 16.2665 8.91281 16.0983 9.11364 16.0983H12.827L18.7002 11.3303C18.8097 11.2414 18.9586 11.2249 19.0838 11.2878Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.8552 19.2408C23.5959 17.6688 22.7013 16.368 21.9579 15.659C21.8103 15.5183 21.8011 15.2806 21.9374 15.1281C22.0736 14.9756 22.3036 14.9661 22.4512 15.1069C23.2836 15.9007 24.2799 17.3428 24.5721 19.1146C24.8685 20.9114 24.4326 23.0052 22.4617 25.0416C22.3197 25.1884 22.0894 25.1884 21.9474 25.0416C21.8054 24.8949 21.8054 24.657 21.9474 24.5103C23.7583 22.6392 24.1104 20.788 23.8552 19.2408Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.918 19.1056C27.5511 16.9338 26.2869 15.1396 25.2338 14.1592C25.0846 14.0203 25.0727 13.7827 25.2071 13.6285C25.3416 13.4744 25.5715 13.462 25.7207 13.6009C26.8629 14.6644 28.233 16.6004 28.6345 18.9764C29.0404 21.3788 28.4468 24.1845 25.7313 26.9234C25.5876 27.0684 25.3573 27.0655 25.2171 26.917C25.0768 26.7686 25.0795 26.5307 25.2232 26.3857C27.7764 23.8105 28.2805 21.2508 27.918 19.1056Z"
      fill="black"
    />
    <line
      x1="8.75"
      y1="30.755"
      x2="29.505"
      y2="10"
      stroke="black"
      strokeWidth="0.7"
      strokeLinecap="round"
    />
  </svg>
);

const UnmutedIcon = () => (
  <svg
    width="23"
    height="18"
    viewBox="0 0 23 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5349 1.09804C11.5349 0.141403 10.3353 -0.356094 9.59707 0.294816L5.13074 4.23205C5.0242 4.32626 4.8841 4.37871 4.73855 4.37889H1.73024C1.27135 4.37889 0.831259 4.55207 0.506776 4.86032C0.182293 5.16858 0 5.58666 0 6.0226V11.5016C0 11.9376 0.182293 12.3557 0.506776 12.6639C0.831259 12.9722 1.27135 13.1454 1.73024 13.1454H4.73855C4.88395 13.1452 5.02402 13.1973 5.13074 13.2911L9.59707 17.2294C10.3353 17.8792 11.5349 17.3828 11.5349 16.4262V1.09804ZM5.91512 5.03528L10.3814 1.09804V16.4262L5.91512 12.4879C5.59514 12.2061 5.17489 12.0495 4.73855 12.0495H1.73024C1.57728 12.0495 1.43058 11.9918 1.32242 11.8891C1.21426 11.7863 1.15349 11.647 1.15349 11.5016V6.0226C1.15349 5.87729 1.21426 5.73793 1.32242 5.63518C1.43058 5.53243 1.57728 5.4747 1.73024 5.4747H4.73855C5.17489 5.47475 5.59514 5.3171 5.91512 5.03528ZM18.1252 1.90913C18.1254 1.90923 18.1255 1.90934 18.4609 1.53857C18.7964 1.16781 18.7965 1.16794 18.7967 1.16808L18.7971 1.16842L18.798 1.1693L18.8008 1.17182L18.8096 1.17994C18.8169 1.18671 18.8271 1.1962 18.8399 1.20836C18.8655 1.23268 18.9017 1.2677 18.947 1.3131C19.0376 1.40386 19.1648 1.53626 19.3163 1.7076C19.619 2.04991 20.0206 2.54976 20.4221 3.1855C21.2234 4.45412 22.0379 6.28639 22.0379 8.49828C22.0379 10.7038 21.2275 12.7034 20.437 14.1339C20.0399 14.8525 19.6428 15.4363 19.3442 15.8416C19.1948 16.0444 19.0696 16.203 18.9808 16.312C18.9365 16.3665 18.9011 16.4087 18.8764 16.4377L18.8475 16.4715L18.8393 16.4809L18.8368 16.4836L18.836 16.4846L18.8357 16.4849C18.8356 16.485 18.8355 16.4852 18.4609 16.154C18.0864 15.8228 18.0863 15.8229 18.0862 15.8229L18.087 15.822L18.0921 15.8162L18.1146 15.79C18.1349 15.7661 18.1657 15.7293 18.2055 15.6805C18.285 15.5829 18.4002 15.437 18.5392 15.2484C18.8175 14.8707 19.1897 14.3236 19.5618 13.6502C20.3097 12.2968 21.0379 10.4686 21.0379 8.49828C21.0379 6.53435 20.3139 4.88676 19.5767 3.71949C19.2089 3.13728 18.8414 2.68017 18.5671 2.37001C18.4302 2.21511 18.317 2.0974 18.2393 2.0196C18.2005 1.98072 18.1706 1.95186 18.1511 1.93336L18.1299 1.91344L18.1255 1.90939L18.1252 1.90913ZM13.8467 1.53857C13.5535 1.94361 13.5534 1.94352 13.5533 1.94344L13.554 1.94398L13.5599 1.94835L13.5873 1.96894C13.6123 1.98788 13.6502 2.01719 13.6993 2.05653C13.7975 2.13522 13.94 2.25382 14.1122 2.40957C14.457 2.72158 14.9175 3.17988 15.3773 3.76232C16.3017 4.93322 17.1928 6.56594 17.1928 8.49828C17.1928 10.4393 16.2949 12.2522 15.3584 13.6079C14.8937 14.2805 14.4285 14.8277 14.0799 15.2062C13.9058 15.3952 13.7614 15.5415 13.6616 15.6396C13.6117 15.6886 13.5729 15.7255 13.5472 15.7497L13.5187 15.7763L13.5123 15.7822L13.5111 15.7833C13.5111 15.7833 13.5112 15.7832 13.8467 16.154C14.1821 16.5247 14.1823 16.5246 14.1824 16.5245L14.1827 16.5242L14.1837 16.5233L14.1867 16.5206L14.1967 16.5114L14.2325 16.478C14.2632 16.4492 14.3071 16.4073 14.3623 16.353C14.4728 16.2444 14.6289 16.0862 14.8154 15.8837C15.1879 15.4793 15.6843 14.8955 16.1811 14.1762C17.1677 12.7481 18.1928 10.7331 18.1928 8.49828C18.1928 6.25479 17.1609 4.40767 16.1622 3.14267C15.6605 2.50716 15.1594 2.0085 14.7831 1.66804C14.5947 1.49755 14.4367 1.36603 14.3246 1.27617C14.2685 1.23123 14.2238 1.19665 14.1924 1.17278C14.1767 1.16084 14.1643 1.15157 14.1555 1.14502L14.1449 1.13723L14.1417 1.13487L14.1406 1.13408L14.1402 1.13378C14.14 1.13365 14.1398 1.13354 13.8467 1.53857Z"
      fill="#5C5C5C"
    />
  </svg>
);

const ToastErrorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none">
    <rect width="48" height="48" fill="#F94F44" rx="24" />
    <g fill="#fff" fill-rule="evenodd" clip-rule="evenodd" filter="url(#a)">
      <path d="M24 16.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM15.5 24a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0Z" />
      <path d="M21.058 21.059a.2.2 0 0 1 .283 0l5.6 5.6a.2.2 0 0 1-.282.283l-5.6-5.6a.2.2 0 0 1 0-.283Z" />
      <path d="M20.705 20.705a.7.7 0 0 1 .99 0l5.6 5.6a.7.7 0 1 1-.99.99l-5.6-5.6a.7.7 0 0 1 0-.99Z" />
      <path d="M26.941 21.059a.2.2 0 0 1 0 .282l-5.6 5.6a.2.2 0 0 1-.283-.282l5.6-5.6a.2.2 0 0 1 .283 0Z" />
      <path d="M26.305 20.705a.7.7 0 1 1 .99.99l-5.6 5.6a.7.7 0 1 1-.99-.99l5.6-5.6Z" />
    </g>
    <defs>
      <filter
        id="a"
        width="40"
        height="40"
        x="4"
        y="8"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2867_5073" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_2867_5073" result="shape" />
      </filter>
    </defs>
  </svg>
);

const ToastSuccessIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none">
    <rect width="48" height="48" fill="#4FB69D" rx="24" />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="m27.478 21.565-5.217 4.87-1.74-1.74"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M24 32a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
    />
  </svg>
);

export {
  ToastSuccessIcon,
  ToastErrorIcon,
  UnmutedIcon,
  MutedIcon,
  DragAndDropIcon,
  ReplyIcon,
  SendMessageIcon,
  SmileIcon,
  CalendarIcon,
  LiveIcon,
  HidePasswordIcon,
  ShowPasswordIcon,
  BillingIcon,
  RefreshIcon,
  UserCountIcon,
  ChevronIcon,
  InfoIcon,
  SearchIcon,
  EditIcon,
  AddIcon,
  TrashIcon,
  EditButtonIcon,
  UploadFileIcon,
  FileIcon,
  TimesIcon,
  DownloadIcon,
  CheckIcon,
  PublishIcon,
  CheckboxIcon,
  CheckboxCheckedIcon,
  EyeIcon,
  EyeDashIcon,
  CaretDownMenuIcon,
  CaretDownIcon,
  CaretLeftIcon,
  CaretRightIcon,
  IconError,
  CloseIcon,
};
